import axios from "axios";
import { addToast } from "@/composables/toast";

const ax = axios.create();

ax.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
ax.defaults.baseURL = "/api/";

function showErrorToast(error: any) {
    const statusCode = error?.response?.status;
    const errors = error?.response?.data?.errors;
    const firstMessage =
        errors && typeof errors === "object"
            ? Object.values(errors)
                  .flat()
                  .find((m) => typeof m === "string")
            : null;

    addToast({
        severity: "error",
        summary: statusCode ? `${statusCode} Error` : "Request Error",
        detail: firstMessage ?? "Please check the entered values.",
    });
}

export default {
    async get(url: string) {
        try {
            const response = await ax.get(url);
            return response.data;
        } catch (error: any) {
            if (error.response?.status === 403) {
                if (import.meta.env.DEV) showErrorToast(error);
                else window.location.replace("/error/403");
                throw error;
            }
            if (error.response?.status === 404) {
                if (import.meta.env.DEV) showErrorToast(error);
                else window.location.replace("/error/404");
                throw error;
            }
            if (
                error.response?.status === 422 ||
                error.response?.status === 500
            ) {
                showErrorToast(error);
                throw error;
            } else {
                throw error;
            }
        }
    },
    async post(url: string, req: any = {}) {
        try {
            const response = await ax.post(url, req);
            return response.data;
        } catch (error: any) {
            if (error.response?.status === 403) {
                if (import.meta.env.DEV) showErrorToast(error);
                else window.location.replace("/error/403");
                throw error;
            }
            if (error.response?.status === 404) {
                if (import.meta.env.DEV) showErrorToast(error);
                else window.location.replace("/error/404");
                throw error;
            }
            if (
                error.response?.status === 422 ||
                error.response?.status === 500
            ) {
                showErrorToast(error);
                throw error;
            } else {
                throw error;
            }
        }
    },
    async put(url: string, req: any = {}) {
        try {
            const response = await ax.put(url, req);
            return response.data;
        } catch (error: any) {
            if (error.response?.status === 403) {
                if (import.meta.env.DEV) showErrorToast(error);
                else window.location.replace("/error/403");
                throw error;
            }
            if (error.response?.status === 404) {
                if (import.meta.env.DEV) showErrorToast(error);
                else window.location.replace("/error/404");
                throw error;
            }
            if (
                error.response?.status === 422 ||
                error.response?.status === 500
            ) {
                showErrorToast(error);
                throw error;
            } else {
                throw error;
            }
        }
    },
    async delete(url: string) {
        try {
            const response = await ax.delete(url);
            return response.data;
        } catch (error: any) {
            if (error.response?.status === 403) {
                if (import.meta.env.DEV) showErrorToast(error);
                else window.location.replace("/error/403");
                throw error;
            }
            if (error.response?.status === 404) {
                if (import.meta.env.DEV) showErrorToast(error);
                else window.location.replace("/error/404");
                throw error;
            }
            if (
                error.response?.status === 422 ||
                error.response?.status === 500
            ) {
                showErrorToast(error);
                throw error;
            } else {
                throw error;
            }
        }
    },
};

// Mock api errors
export function error(errors: { [key: string]: string[] }) {
    throw {
        response: {
            data: {
                errors,
            },
        },
    };
}
